import { Typography } from "@mui/material";

export const DenounceBenefits = [
   {
      title: "Fomenta la mejora continua",
      description: (
         <Typography>
            Un medio de comunicación seguro y estable puede facilitar la retroalimentación de sus servicios y/o
            productos, permitiendo establecer la mejora continua y asegurando la máxima satisfacción de las partes
            interesadas.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/canal-denuncias/fondos/image+13.png",
   },
   {
      title: "Detección temprana de problemas",
      description: (
         <Typography>
            Nuestro Canal de Denuncias permite identificar de manera temprana el 45% de los problemas internos de la
            organización. Lo que brinda la oportunidad de tomar medidas preventivas y correctivas de manera oportuna,
            evitando riesgos y contingencias futuras.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/canal-denuncias/fondos/9+2.png",
   },
   {
      title: "Reducción de riesgos y contingencias legales",
      description: (
         <Typography>
            Esta implementación puede reducir de manera significativa los riesgos vinculados al incumplimiento de las
            obligaciones, evitando sanciones de alto impacto para la organización y afectar su reputación de manera
            perjudicial.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/proximo-servicio/image+20.png",
   },
   {
      title: "Fomenta una sólida reputación empresarial",
      description: (
         <Typography>
            Implementar y mantener un Canal de Denuncias permite crear una buena reputación ante competidores y otras
            organizaciones, ya que en la actualidad, las relaciones comerciales, se ven influenciadas mayormente, por
            aspectos cualitativos.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/canal-denuncias/fondos/image+11.png",
   },
   {
      title: "Integración de identidad corporativa",
      description: (
         <Typography>
            Incluya su identidad corporativa en la plataforma de interposición de denuncias, quejas y sugerencias, para
            fomentar su uso y la creación de una cultura de cumplimiento.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/canal-denuncias/fondos/image+14.png",
   },
];

export const GovernanceBenefits = [
   {
      //icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/iconos/ICONOS~4.SVG)",
      title: "Seguridad total para su información confidencial",
      description: (
         <Typography>
            Garantizamos la protección constante de sus datos sensibles mediante sistemas de acceso adaptados a cada
            usuario, cumpliendo rigurosos estándares de seguridad de la información.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/carrousel/lecosy3+1.png",
   },
   {
      //icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/iconos/Iconos+BENEFICIOS+GOBIERNO+CORPORATIVO_Promoci%C3%B3n+del+intercambio+de+conocimiento.svg)",
      title: "Promoción del intercambio de conocimiento",
      description: (
         <Typography>
            Impulsamos estrategias para adquirir, crear y compartir conocimiento entre consejeros y miembros de su
            organización. Esto potencia el rendimiento del equipo, aprovecha la experiencia existente y fomenta una
            cultura de aprendizaje constante.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/fondos/image+13.png",
   },
   {
      //icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/iconos/Iconos+BENEFICIOS+GOBIERNO+CORPORATIVO_Evaluaci%C3%B3n+y+mejora+del+desempe%C3%B1o.svg)",
      title: "Evaluación y mejora del desempeño",
      description: (
         <Typography>
            Proporcionamos una medición detallada del desempeño de los órganos de gobierno y sus miembros, identificando
            oportunidades de mejora a través de informes exhaustivos para una evolución constante en su estructura de
            gobierno.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gob-corp-car-3.png",
   },
   {
      //icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/iconos/Iconos+BENEFICIOS+GOBIERNO+CORPORATIVO_Optimizaci%C3%B3n+de+la+gesti%C3%B3n+de+la+informaci%C3%B3n.svg)",
      title: "Optimización de la gestión de la información",
      description: (
         <Typography>
            Simplificamos la organización, búsqueda y seguridad de documentos clave, ofreciendo visibilidad total de sus
            recursos. Esto le permite tomar decisiones respaldadas por datos precisos, ahorrando tiempo y reforzando la
            eficiencia operativa.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gob-corp-car-4.png",
   },
   {
      //icon: "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/gobierno-corporativo/iconos/Iconos+BENEFICIOS+GOBIERNO+CORPORATIVO_Evaluaci%C3%B3n+y+mejora+del+desempe%C3%B1o.svg)",
      title: "Acceso a reuniones en multiplataforma",
      description: (
         <Typography>
            El módulo ofrece acceso desde cualquier dispositivo con conexión a internet, desde Windows, Mac, o de
            dispositivos móviles como iOS y Android. Esto asegura que los usuarios puedan utilizar la plataforma de
            manera flexible y sin limitaciones.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/proximo-servicio/image+17.png",
   },
];
export const BeneficialOwnerBenefits = [
   {
      title: "Reducción de riesgos",
      description: (
         <Typography>
            Evite sanciones relacionadas con los artículos 84-M y 84-N del Código Fiscal Federal de la Federación al
            mantener una base de datos integral y actualizada de los beneficiarios controladores.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/beneficiarioControlador/section-8-1.png",
   },
   {
      title: "Respuesta rápida ante requerimientos de la autoridad",
      description: (
         <Typography>
            Obtenga los mecanismos necesarios para cumplir con las obligaciones legales y tributarias de control de
            información de beneficiarios, controladores y de socios, accionistas correspondientes.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/beneficiarioControlador/section-8-2.png",
   },
   {
      title: "Identificación objetiva de los beneficiarios controladores",
      description: (
         <Typography>
            Reciba formación especializada para identificar correctamente a los beneficiarios controladores y asegurar
            la efectividad de sus controles, evitando posibles sanciones.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/beneficiarioControlador/section8-3.png",
   },
];

export const RepseBenefits = [
   {
      title: "Gestión de cumplimiento",
      description: (
         <Typography>
            Optimice la gestión de sus actividades y servicios especializados, minimizando el riesgo de sanciones y
            asegurando el cumplimiento del REPSE.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/REPSE+-+Gesti%C3%B3n+de+cumplimiento.mp4",
   },
   {
      title: "Gestión centralizada de información",
      description: (
         <Typography>
            Administre de manera integral y centralizada la documentación que respalda el cumplimiento legal y fiscal de
            sus obligaciones, generando la materialidad correspondiente.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/REPSE+-+Gesti%C3%B3n+centralizada+de+informacion.mp4",
   },
   {
      title: "Generación automática de reportes",
      description: (
         <Typography>
            Simplifique la elaboración de informes de cumplimiento legal y fiscal, facilitando la rendición de cuentas y
            el análisis interno.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/REPSE+-+Generaci%C3%B3n+automatica+de+reportes.mp4",
   },
   {
      title: "Control de cumplimiento de prestadoras de servicios especializados",
      description: (
         <Typography>
            Monitoree el cumplimiento de sus prestadoras de servicios, facilitando la responsabilidad solidaria y
            reduciendo riesgos legales y fiscales.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/REPSE+-+Control+de+cumplimiento+de+prestadores+de+servicios+especializados.mp4",
   },
   {
      title: "Facilitación de firmas de contratos",
      description: (
         <Typography>
            Facilite la creación, firma electrónica y seguimiento de contratos, optimizando recursos y garantizando su
            validez legal con fecha cierta.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/REPSE+-+Facilitaci%C3%B3n+de+firmas+de+contratos.mp4",
   },
];

export const SirocBenefits = [
   {
      title: "Gestión de cumplimiento",
      description: (
         <Typography>
            Asegure el cumplimiento completo del SIROC, minimizando el riesgo de sanciones y optimizando la gestión de
            sus obras.
         </Typography>
      ),
      videoUrl: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/SIROC+-+Gestion+de+cumplimiento.mp4",
   },
   {
      title: "Gestión centralizada de información",
      description: (
         <Typography>
            Administre de manera integral y centralizada la documentación que respalde sus obras, generando la
            materialidad correspondiente.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/SIROC+-+Gestion+centralizada+de+informacion.mp4",
   },
   {
      title: "Generación automática de reportes",
      description: (
         <Typography>
            Simplifique la elaboración de informes de cumplimiento, facilitando la rendición de cuentas y el análisis
            interno.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/SIROC+-+Generacion+automatica+de+reportes.mp4",
   },
   {
      title: "Control de cumplimiento de contratistas y subcontratistas",
      description: (
         <Typography>
            Monitoree el cumplimiento de sus contratistas y subcontratistas, facilitando la responsabilidad solidaria y
            reduciendo riesgos legales y fiscales.
         </Typography>
      ),
      videoUrl:
         "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/SIROC+-+Control+de+cumplimiento+de+contratistas+y+subcontratistas.mp4",
   },
];

export const ComplianceProgramBenefits = [
   {
      title: "Implementar una sólida gestión empresarial",
      description: (
         <Typography>
            Las organizaciones pueden alcanzar su máximo potencial al operar de manera armoniosa y sistemática. Los
            beneficios resultantes son tangibles a corto plazo, repercutiendo positivamente en resultados
            organizacionales y económicos.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/programa-cumplimiento/carrousel/image+9.png",
   },
   {
      title: "Crear una cultura de cumplimiento",
      description: (
         <Typography>
            Contar con disposiciones y lineamientos claros, las partes interesadas actuarán en armonía, garantizando el
            cumplimiento de sus objetivos de manera segura. Estos mecanismos permiten desempeñar las funciones de manera
            más efectiva, lo que les brinda certeza al desempeño de cada una de las áreas.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/programa-cumplimiento/carrousel/36+1.png",
   },
   {
      title: "Generar confianza frente a terceros",
      description: (
         <Typography>
            El compromiso con el Programa de Cumplimiento contribuye a generar confianza a clientes, proveedores,
            asociados, prestadoras de servicios, partes contractuales, instituciones de crédito y entidades públicas,
            entre otros, influyendo en decisiones comerciales en las que se encuentre involucrada.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/programa-cumplimiento/carrousel/image+12.png",
   },
   {
      title: "Contribuir de manera positiva al crecimiento interno",
      description: (
         <Typography>
            Facilitar el flujo efectivo de indicaciones e información de los procesos, mejora la eficacia y aporta
            dinamismo a los resultados positivos, ya que las áreas responsables del cumplimiento son guiadas de manera
            correcta en concordancia con la gestión empresarial y la legislación aplicable.
         </Typography>
      ),
      image: "https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/programa-cumplimiento/carrousel/image+14.png",
   },
];
